// The Input Component

// Libraries
import React, { useState } from "react";
import TextField from "@mui/material/TextField";

// Input Component
function Input({
  type = "text",
  name = "",
  validate = false,
  placeholder = "Input",
  disabled = false,
  required = false,
  value = "",
  className = "",
  onInputChange,
  onSearch,
  addDateTime,
}) {
  const [show, setShow] = useState(false);

  const onChangeEvent = (e) => {
    onInputChange(e.target.value, name);
  };

  const ShowPassword = () => {
    setShow(!show);
  };

  const keyDown = (e) => {
    // On enter search profiles for ATS only
    if (name === "dateTime") {
      if (e.keyCode === 13) {
        // onSearch(name);
        addDateTime();
      }
    } else {
      if (onSearch) {
        onSearch(name);
      }
    }
  };

  // Render div
  return (
    <div className="relative flex">
      {/* input field */}
      {name == "status" ? (
        <input
          type="text"
          name={name}
          placeholder={placeholder}
          value={value}
          className={`font-text w-full h-10 text-sm text-black-1 placeholder-white-3 rounded border-white-3 bg-white-1 border px-3 py-1 ${className}`}
          onChange={onChangeEvent}
          onKeyDown={keyDown}
        />
      ) : (
        <TextField
          id="outlined-name"
          label={placeholder}
          value={value}
          className={`font-text w-full text-sm h-12 text-black-1 placeholder-white-3 transition-colors border-white-3 bg-white-1  ${className}`}
          onChange={onChangeEvent}
          onKeyDown={keyDown}
          required
        />
      )}
    </div>
  );
}

// Export the Component
export default Input;
